import { Button, CircularProgress, InputAdornment } from '@material-ui/core';
import ExpansionPanel from '@material-ui/core/ExpansionPanel';
import ExpansionPanelDetails from '@material-ui/core/ExpansionPanelDetails';
import ExpansionPanelSummary from '@material-ui/core/ExpansionPanelSummary';
import Typography from '@material-ui/core/Typography';
import ExpandMoreIcon from '@material-ui/icons/ExpandMore';
import MyTable, { MyTableBody, MyTableCol, MyTableRow } from 'components/MyTable';
import PermissionHide from 'components/PermissionHide';
import Spin from 'components/Spin';
import Truncate from 'components/Truncate';
import { Field, Form, Formik } from 'formik';
import React, { useState } from 'react';
import { toast } from 'react-toastify';
import { useCallbackObservable, useObservable } from 'react-use-observable';
import { tap } from 'rxjs/operators';
import { TextFormField } from 'v2/components/Shared/FormFields/TextFormField';
import ordersService from 'v2/services/orders';

import type { IInvoiceItem } from 'v2/components/Pages/Orders/interfaces';

import type { FormikProps } from 'formik';

const Tracking = () => {
  const [isSendingTrackingCode, setIsSendingTrackingCode] = useState<boolean>(false);
  const [isLoading] = useObservable(() => ordersService.isLoadingInvoiceItems(), []);
  const [invoiceItems] = useObservable(() => {
    return ordersService.getInvoiceItems();
  }, []);

  const [onSendDeliveryCode] = useCallbackObservable((values: IInvoiceItem, form: FormikProps<IInvoiceItem>) => {
    setIsSendingTrackingCode(true);
    return ordersService.sendDeliveryCodeInvoiceItem(values).pipe(
      tap(() => {
        try {
          setIsSendingTrackingCode(false);
          form.setSubmitting(false);
          toast.success('Código de rastreio cadastrado com sucesso');
        } catch (error) {
          setIsSendingTrackingCode(false);
          toast.error(error);
        }
      })
    );
  }, []);

  return (
    <PermissionHide action='myeduzz:minhas-entregas:editar'>
      <ExpansionPanel>
        <ExpansionPanelSummary expandIcon={<ExpandMoreIcon />} aria-controls='tracking-content' id='tracking-header'>
          <Typography>Rastreio</Typography>
        </ExpansionPanelSummary>
        <Typography style={{ fontSize: 15, color: '#f50057', padding: '8px 24px 8px' }}>
          Ao enviar o código de rastreio o status da entrega será atualizado para <b>ENVIADO</b> automaticamente.
        </Typography>
        <ExpansionPanelDetails>
          {isLoading ? (
            <div style={{ width: '100%', textAlign: 'center' }}>
              <Spin />
            </div>
          ) : (
            <MyTable>
              <MyTableBody>
                {Array.isArray(invoiceItems) && invoiceItems.length
                  ? invoiceItems.map((item: IInvoiceItem) => (
                      <MyTableRow key={`item-${item.id}`}>
                        <MyTableCol>
                          {item.id} -{' '}
                          <Truncate style={{ display: 'inline' }} final='.' count={10}>
                            {item.description}
                          </Truncate>
                        </MyTableCol>
                        <MyTableCol>
                          <Formik initialValues={item} onSubmit={onSendDeliveryCode}>
                            {({ values, isSubmitting }: FormikProps<IInvoiceItem>) => {
                              return (
                                <Form>
                                  <Field
                                    placeholder='Código'
                                    id='order.traking_code'
                                    name='order.traking_code'
                                    fullWidth={true}
                                    value={values.order.traking_code ? values.order.traking_code : null}
                                    InputLabelProps={{ shrink: true }}
                                    component={TextFormField}
                                    InputProps={{
                                      endAdornment: (
                                        <InputAdornment position='end'>
                                          {isSendingTrackingCode ? (
                                            <CircularProgress size={14} />
                                          ) : (
                                            <Button
                                              disabled={
                                                isSubmitting || !values.order.traking_code || item.order.traking_code === values.order.traking_code
                                              }
                                              type='submit'
                                              style={{ minWidth: 'auto' }}
                                              fullWidth
                                              color='default'
                                            >
                                              ok
                                            </Button>
                                          )}
                                        </InputAdornment>
                                      ),
                                    }}
                                  />
                                </Form>
                              );
                            }}
                          </Formik>
                        </MyTableCol>
                      </MyTableRow>
                    ))
                  : 'Nenhum item encontrado...'}
              </MyTableBody>
            </MyTable>
          )}
        </ExpansionPanelDetails>
      </ExpansionPanel>
    </PermissionHide>
  );
};
export default Tracking;
